/**
 * @format
 */

import React from 'react';
import {
  Dimensions,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { Rating } from 'react-native-elements';

const debug = require('debug')('se:advertitem');

const { width: windowWidth } = Dimensions.get('window');

import ThumbtackItem from '../../ThumbtackItem';
import { ThumbtackPro } from '../../../api/adserver';
import config from '../../../lib/config';

export interface ThumbtackAdvertListItemProps {
  professional: ThumbtackPro;
  onPress: (item: ThumbtackPro) => void;
  hideText?: boolean;
  margin?: number;
}

const ThumbtackAdvertListItem: React.FC<ThumbtackAdvertListItemProps> = ({
  professional,
  onPress,
}) => {
  const handleOnPress = () => {
    onPress(professional);
  };

  const topImageUrl = professional.image_url;

  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={handleOnPress}>
        <ThumbtackItem
          uri={topImageUrl}
          style={styles.mainImage}
          stars={professional.rating}
          numReviews={professional.num_reviews}
          buisnessName={professional.business_name}
        />
      </TouchableOpacity>
    </View>
  );
};

const widthFeaturePadding = 8;
const itemFeatureWidth = windowWidth - (21 + widthFeaturePadding);
const featureItemHeight =
  itemFeatureWidth * config.theme.advert.imageHeightRatio;
const totalFeatureItemWidth = itemFeatureWidth + widthFeaturePadding;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginTop: 15,
    padding: 10,
  },
  headingsDetailContainer: {
    marginTop: 15,
  },
  slideFeatureContainer: {
    height: featureItemHeight,
    width: totalFeatureItemWidth,
    margin: 0,
  },
  mainImage: {
    width: 100,
    height: 100,
    borderRadius: 0,
    borderWidth: config.theme.carousel.imageBorder,
    borderColor: config.theme.carousel.imageBorderColor,
    resizeMode: 'contain',
  },
  detailText: {
    fontSize: 13,
    color: config.theme.advert.subSectionHeadingTextColor,
  },
  bottomMargin1Em: {
    marginBottom: 14,
  },
  featureHeading: {
    fontSize: config.theme.headingFontSize,
    fontWeight: config.theme.headingFontWeight,
    color: config.theme.headingTextColor,
    marginBottom: 10,
  },
});

export default ThumbtackAdvertListItem;
